import React from 'react';

import classnames from 'classnames';

import { Radios } from '@components/Forms/Radios';

import { FormattedTermToAssign, TermToAssign } from '@domain/districts/types';

import { getTermStringFromObject } from '@use-cases/districts';

import { useTranslation } from '@external/react-i18next';

import { Maybe } from '@typings/graphql';

interface Props {
  termsToAssign: TermToAssign[];
  selectedTerm: Maybe<TermToAssign>;
  onChangeTerm?: (term: TermToAssign) => void;
  termsSelector?: string;
  label?: string;
  classes?: {
    optionWrapper?: string;
    optionsWrapper?: string;
    radioBtn?: string;
  };
}

const SelectTerm = ({
  termsToAssign,
  termsSelector = 'available-terms',
  selectedTerm,
  label = 'Available Terms',
  onChangeTerm,
  classes,
}: Props) => {
  const { t } = useTranslation();

  const formattedTerms: FormattedTermToAssign[] = termsToAssign?.map(
    details => ({
      label: getTermStringFromObject(details),
      value: getTermStringFromObject(details),
      disabled: details.isDisabled || false,
      details,
    })
  );

  const formattedSelectedTerm = formattedTerms?.find(
    item =>
      item.details.startDate === selectedTerm?.startDate &&
      item.details.endDate === selectedTerm?.endDate
  );

  const changeHandler = (termLabel: string) => {
    const selectedTerm = formattedTerms?.find(item => item.label === termLabel)
      ?.details;

    selectedTerm && onChangeTerm?.(selectedTerm);
  };

  return termsToAssign.length > 1 ? (
    <div className="mt-4">
      <Radios
        id={termsSelector}
        name={termsSelector}
        legend={t(termsSelector, label)}
        value={formattedSelectedTerm?.value || formattedTerms[0]?.value}
        options={formattedTerms?.map(({ value, label, disabled }) => ({
          value,
          label,
          disabled,
        }))}
        changeHandler={changeHandler}
        classes={{
          optionsWrapper: classnames({
            flex: true,
            [classes?.optionsWrapper || '']: !!classes?.optionsWrapper,
          }),
          optionWrapper: classnames({
            'mr-8': true,
            [classes?.optionWrapper || '']: !!classes?.optionWrapper,
          }),
          radioBtn: classnames({
            'z-0': true,
            [classes?.radioBtn || '']: !!classes?.radioBtn,
          }),
        }}
      />
    </div>
  ) : null;
};

export default SelectTerm;
